import { useCallback } from 'react'
import { Action } from '../state/AppProvider'
import { useWebSocket } from './useWebSocket'

export const useNotifications = (dispatch: React.Dispatch<Action>) => {
  const onMessage = useCallback((type: string, data: any) => {
    if (type === 'notification') {
      dispatch({ type: 'ADD_NOTIFICATION', payload: { ...data, created_at: new Date() } })
    }
  }, [])

  const { isConnected, sendMessage } = useWebSocket({
    onMessage,
  })

  return { isConnected, sendMessage }
}
